import { makeFinancialProductSelectedLogicRecord } from './logic';
export var getMakeFinancialProductSelectedLogic = function (financialProduct) {
    var makeLogic = makeFinancialProductSelectedLogicRecord[financialProduct];
    return makeLogic;
};
